import PlusIcon from 'assets/icons/plus';
import CashReceipts from 'components/features/cash-receipts';
import CustomButton from 'components/ui/custom-button';
import { EButtonVariant } from 'components/ui/custom-button/enums';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ENavigationPath } from 'constants/path';

function ListReceipts() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <HomeLayout title={t('receipts.receipts')}>
      <div className="flex justify-end">
        <CustomButton
          variant={EButtonVariant.PRIMARY}
          label={t('receipts.createNewReceipt')}
          prefixIcon={<PlusIcon color="#fff" />}
          onClick={() => navigate(ENavigationPath.NEW_RECEIPT)}
          className="mt-[16px] px-4"
        />
      </div>

      <div className="bg-[#E3F2FB] p-[10px] rounded-lg my-[20px]">
        <CashReceipts />
      </div>
    </HomeLayout>
  );
}

export default ListReceipts;
